import api from "../../api";
import { getEventIndexById } from "./utils";

function formatEvents(events) {
  let newEvents = [];
  if (events) {
    events.forEach((event) => {
      newEvents.push({
        // FullCalendar Properties
        id: event.Id,
        title: event.Title,
        start: event.EndDate, // Setting the start = EndDate causes the calendar to only show the EndDate of every event
        end: event.EndDate,
        allDay: event.AllDay,
        color: formatEventColor(event), //event.Color

        // Extra properties
        isTask: false,
        agendaType: event.AgendaType,
        createdBy: event.CreatedBy,
        description: event.Description,
        endDate: event.EndDate, // Extra property for EndDate to display in forms because "end" appears as null
        startDate: event.StarDate, // Extra property for StartDate to display in forms
        frequency: event.Frequency,
        employeeId: event.EmployeeId,
        completed: event.Completed,
        evidence: event.Evidence,
        startDateMonth: new Date(event.startDateMonth),
        Time: event.TimeEstimated,
        minutesHours: event.MinuteHour,
        fixed: event.IsFixed
      });
    });
    return newEvents;
  }
  return newEvents;
}

function formatEventColor(event) {
  if (event.Completed) {
    return "#368939";
  }
  return "#ff352e";
}

const state = {
  events: [],
  calendarsForUser: [],
  weekendsVisible: true,
  eventsAreLoading: true,
  tasksAreLoading: true,
  calendarsAreLoading: true,
  firstCalendar: undefined,
  calendarCreatedBy: 0,
  calendarResponsible: 0
};

const getters = {
  events: (state) => state.events,
  calendarsForUser: (state) => state.calendarsForUser,
  weekendsVisible: (state) => state.weekendsVisible,
  eventsAreLoading: (state) => state.eventsAreLoading,
  tasksAreLoading: (state) => state.tasksAreLoading,
  firstCalendar: (state) => state.firstCalendar,
  calendarCreatedBy: (state) => state.calendarCreatedBy,
  getCalendarResponsible: (state) => state.calendarResponsible
};

const actions = {
  getAllCalendarsForEmployee: ({ commit }, payload) => {
    // commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .get(
          `/api/CalendarioMaintenance/GetCalendariosByEmployeeID?employeeID=${payload.employeeID}&DirectionID=${payload.DirectionID}&CompanyID=${payload.CompanyID}`
        )
        .then((resp) => {
          commit("getAllCalendarsForEmployee", resp.data);
          resp.data.length > 0
            ? commit("setFirstCalendar", resp.data[0].ID)
            : commit("setFirstCalendar", undefined);
          commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  GetPersonalCalendario: ({ commit }, employeeID) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .get("/api/CalendarioMaintenance/GetPersonalCalendario", {
          params: {
            employeeID: employeeID
          }
        })
        .then((resp) => {
          commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  GetCalendario: ({ commit }, payload) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .get(
          `/api/CalendarioMaintenance/GetCalendarioByID?calendarioID=${payload.calendarioID}&agendaType=${payload.agendaType}&employeeId=${payload.employeeId}`
        )
        .then((resp) => {
          const events = formatEvents(resp.data.AgendaMaintenance);
          commit("init", events);
          commit("CalendarCreatedBy", resp.data.CreatedBy);
          commit("CalendarResponsible", resp.data.ResponsibleId);
          commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  CreateCalendario: ({ commit }, payload) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .post("/api/CalendarioMaintenance/CreateCalendario", {
          EmployeeID: payload.employeeID,
          CalendarTitle: payload.calendarioTitle,
          DirectionID: payload.DirectionID,
          TypeStrategic: payload.TypeStrategic,
          CompanyID: payload.CompanyID,
          EmployeeResponsable: payload.EmployeeResponsable,
          PerspectiveID: payload.PerspectiveID
        })
        .then((resp) => {
          commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  DeleteCalendario: ({ commit }, payload) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .delete("/api/CalendarioMaintenance/DeleteCalendar", {
          data: {
            CalendarID: payload.CalendarID,
            EmployeeID: payload.EmployeeID
          }
        })
        .then(({ data }) => {
          commit("toggle_events_are_loading", false);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
          this.$message.error("Error al eliminar calendario");
        });
    });
  },
  create: ({ commit }, event) => {
    return new Promise((resolve, reject) => {
      api
        .post(
          "/api/AgendaMaintenance/add?frecuency=" + event.frecuency,
          event.agenda
        )
        .then((resp) => {
          commit("create", event);

          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  update: (_, event) => {
    return new Promise((resolve, reject) => {
      api
        .put("/api/AgendaMaintenance/edit", event)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete: (_, event) => {
    return new Promise((resolve, reject) => {
      api
        .delete("/api/AgendaMaintenance/delete", {
          data: event
        })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  init: (state, data) => {
    state.events = data;
  },
  create: (state, event) => {
    // Curerntly not being used, instead another GET call is being made to retrieve list of Events
    state.events.push(event);
  },
  update: (state, updatedEvent) => {
    // Curerntly not being used, instead another GET call is being made to retrieve list of Events
    const index = getEventIndexById(state, updatedEvent.ID);

    if (index === -1) {
      return console.warn(`Unable to update event (id ${updatedEvent.ID})`);
    }

    return state.events.splice(index, 1, {
      ...state.events[index],
      title: updatedEvent.title,
      start: updatedEvent.start,
      end: updatedEvent.end,
      date: updatedEvent.date
    });
  },
  getAllCalendarsForEmployee: (state, data) => {
    state.calendarsForUser = data;
  },
  set_weekends_visible: (state, enabled) => {
    state.weekendsVisible = enabled;
  },
  toggle_events_are_loading: (state, boolean) => {
    state.eventsAreLoading = boolean;
  },
  setFirstCalendar: (state, data) => {
    state.firstCalendar = data;
  },
  CalendarCreatedBy: (state, data) => {
    state.calendarCreatedBy = data;
  },
  CalendarResponsible: (state, data) => {
    state.calendarResponsible = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
